export const groupDataByField = (data, field) => {
  return (
    Array.isArray(data) &&
    data.length > 0 &&
    data.reduce((acc, item) => {
      const key = item[field] != null ? item[field] : 'N/A';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {})
  );
};

export const sortDataByField = (data, field) => {
  return data.sort((a, b) => ('' + a[field]).localeCompare(b[field] + ''));
};
